import React from "react";
import HeaderButton from "./HeaderButton";

import styled from "./Header.module.css";

const Header = function (props) {
  return (
    <React.Fragment>
      <header className={styled.header}>
        <h1>React_Hello</h1>
        <div>
          <HeaderButton text={"My Creator"} onClick={props.onCreator} />
          <HeaderButton text={"Instructions"} onClick={props.onInstruction} />
        </div>
      </header>
      <div className={styled["main-image"]}></div>
    </React.Fragment>
  );
};

export default Header;
